import React, { useEffect, useState } from 'react';
import { Autocomplete, CircularProgress, TextField } from '@mui/material';
import api from '../../services/api';

export type PickedSupplier = { id: number; name: string };

interface Props {
  value: PickedSupplier | null;
  onChange: (s: PickedSupplier | null) => void;
  label?: string;
  size?: 'small' | 'medium';
  required?: boolean;
}

/** Buscador de proveedores (por nombre). */
const SupplierPicker: React.FC<Props> = ({ value, onChange, label = 'Proveedor', size = 'medium', required }) => {
  const [options, setOptions] = useState<PickedSupplier[]>([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const t = setTimeout(async () => {
      setLoading(true);
      try {
        const res = await api.getSuppliers({ page: 1, pageSize: 20, search: search || undefined });
        setOptions((res.suppliers || []).map((s: any) => ({ id: s.id, name: s.name })));
      } catch {
        setOptions([]);
      } finally {
        setLoading(false);
      }
    }, 250);
    return () => clearTimeout(t);
  }, [search]);

  return (
    <Autocomplete
      options={options}
      value={value}
      loading={loading}
      size={size}
      getOptionLabel={o => o.name}
      isOptionEqualToValue={(a, b) => a.id === b.id}
      onChange={(_, v) => onChange(v)}
      onInputChange={(_, v, reason) => { if (reason === 'input') setSearch(v); }}
      filterOptions={x => x}
      noOptionsText="Sin proveedores con ese nombre (se dan de alta en Proveedores)"
      renderInput={params => (
        <TextField
          {...params}
          label={label}
          required={required}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={18} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default SupplierPicker;
